import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { EntityAgeOptions } from 'enums/onboarding/crm';
import { FormSelectProps, SelectOption } from '@ui';

// components
import { FormSelect } from '@ui';

export type IProps = FormSelectProps;

const EntityAgeSelect = (props: IProps) => {
  const { t } = useTranslation('onboarding');

  const options = useMemo<SelectOption[]>(
    () =>
      Object.values(EntityAgeOptions).map((key) => ({
        id: key,
        label: t(`intake_form.entity_age_options.${key}`),
      })),
    [t],
  );

  return <FormSelect {...props} options={options} />;
};

export default EntityAgeSelect;
